// src/components/inventory/BebidasTable.js
import React from 'react';
import TablaInventario from './TablaInventario';

export const UMBRAL_BEBIDAS = 5;

const COLUMNAS = [
  { clave: 'bebida_id', etiqueta: 'ID', tipo: 'lectura', enCreacion: false },
  { clave: 'name', etiqueta: 'Bebida', tipo: 'texto', requerido: true, placeholder: 'Ej. Gaseosa 400ml' },
  { clave: 'stock', etiqueta: 'Existencias', tipo: 'numero', alinear: 'derecha', placeholder: '0' },
  { clave: 'price', etiqueta: 'Precio', tipo: 'dinero', alinear: 'derecha', placeholder: '0', paso: '1' },
];

// Las bebidas no tienen mínimo propio en la base: el umbral es único.
const estadoFila = (b) => {
  const stock = parseFloat(b.stock);
  if (stock <= 0) return { tono: 'peligro', texto: 'Agotada' };
  if (stock < UMBRAL_BEBIDAS) return { tono: 'aviso', texto: `Menos de ${UMBRAL_BEBIDAS}` };
  return { tono: 'exito', texto: 'Disponible' };
};

function BebidasTable({ isReadOnly }) {
  return (
    <TablaInventario
      titulo="Bebidas"
      descripcion={`Se marcan como escasas por debajo de ${UMBRAL_BEBIDAS} unidades.`}
      recurso="/api/bebidas"
      idKey="bebida_id"
      columnas={COLUMNAS}
      estadoFila={estadoFila}
      etiquetaBuscar="Buscar bebida…"
      nuevoVacio={{ name: '', stock: '', price: '' }}
      aPayloadCrear={(n) => ({
        name: n.name.trim(),
        stock: parseInt(n.stock, 10) || 0,
        price: parseFloat(n.price) || 0,
      })}
      isReadOnly={isReadOnly}
    />
  );
}

export default BebidasTable;
